import React, { useState } from "react";
import axios from "axios";
import { MyApiUrl } from "./services";

const Register = () => {
  const [FullName, setFullName] = useState("");
  const [Email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  const [DoB, setDoB] = useState("");
  const [Address, setAddress] = useState("");
  const [Password, setPassword] = useState("");
  const [referredby, setreferredby] = useState("");

  const [btndisable, setbtndisable] = useState(false);

  const UserRegistration = async () => {
    setbtndisable(true);
    if (FullName === "" || FullName == null) {
      alert("Please Enter Full Name");
    } else if (FullName === "" || FullName == null) {
      alert("Please Enter Email Address");
    } else if (Phone === "" || Phone == null) {
      alert("Please Enter Contact Number");
    } else if (DoB === "" || DoB == null) {
      alert("Please Select Date Of Birth");
    } else if (Address === "" || Address == null) {
      alert("Please Enter Your Address");
    } else if (Password === "" || Password == null) {
      alert("Please Enter Login Password");
    } else {
      var obj = {
        FullName: FullName,
        Email: Email,
        Phone: Phone,
        DoB: DoB,
        Address: Address,
        Password: Password,
        referredby: referredby,
      };
      axios.post(MyApiUrl + "UserRegistration", obj).then((response) => {
        if (response.data === "0") {
          alert("Email Already Exist");
        } else if (response.data) {
          alert("Registration successful, Please Login");
          window.location.href = "/";
        } else {
          setbtndisable(false);
          alert("Login Failed, Email and Password Is Wrong ...!");
        }
      });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <div className="login-account">
          <div className="row h-100">
            <div className="col-lg-6 align-self-start m-b30">
              <div
                className="account-info-area"
                style={{
                  backgroundImage: "url(assets/images/pattern/bg-pattern1.png)",
                }}
              >
                <div className="row h-100 align-items-center">
                  <div className="col-xl-12 col-md-12 col-sm-12">
                    <div className="login-content">
                      <h1 className="title">
                        Liberty Web <span className="text-secondary">Guard</span>
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-7 col-sm-8 mx-auto align-self-center">
              <div className="login-form">
                <div className="login-head">
                  <h3 className="title">Create You Account From Here</h3>
                  {/* <p>Lorem ipsum dolor sit amet consectetur adipiscing</p> */}
                </div>
                <h6 className="login-title">
                  <span>Registration</span>
                </h6>
                <form className="form" method="POST" action="#">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group m-b30">
                        <label className="form-label text-secondary">
                          Full Name
                        </label>
                        <div className="input-group input-line">
                          <input
                            name="dzEmail"
                            required
                            type="text"
                            className="form-control"
                            placeholder="Your Full Name"
                            value={FullName}
                            onChange={(event) => {
                              setFullName(event.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group m-b30">
                        <label className="form-label text-secondary">
                          Email Address
                        </label>
                        <div className="input-group input-line">
                          <input
                            name="dzEmail"
                            required
                            type="text"
                            className="form-control"
                            placeholder="info@example.com"
                            value={Email}
                            onChange={(event) => {
                              setEmail(event.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group m-b30">
                        <label className="form-label text-secondary">
                          Contact Number
                        </label>
                        <div className="input-group input-line">
                          <input
                            name="dzEmail"
                            required
                            type="number"
                            className="form-control"
                            placeholder="Enter Contact Number"
                            value={Phone}
                            onChange={(event) => {
                              setPhone(event.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group m-b30">
                        <label className="form-label text-secondary">
                          Date Of Birth
                        </label>
                        <div className="input-group input-line">
                          <input
                            name="dzEmail"
                            required
                            type="date"
                            className="form-control"
                            placeholder="info@example.com"
                            value={DoB}
                            onChange={(event) => {
                              setDoB(event.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group m-b30">
                        <label className="form-label text-secondary">
                          Address
                        </label>
                        <div className="input-group input-line">
                          <input
                            name="dzEmail"
                            required
                            type="text"
                            className="form-control"
                            placeholder="Enter Full Address"
                            value={Address}
                            onChange={(event) => {
                              setAddress(event.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group m-b30">
                        <label className="form-label text-secondary">
                          Password
                        </label>
                        <div className="secure-input input-line">
                          <input
                            type="password"
                            name="password"
                            className="form-control dz-password"
                            placeholder="**********"
                            value={Password}
                            onChange={(event) => {
                              setPassword(event.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group m-b30">
                        <label className="form-label text-secondary">
                          reference code
                        </label>
                        <div className="secure-input input-line">
                          <input
                            type="password"
                            name="password"
                            className="form-control dz-password"
                            placeholder="reference code"
                            value={referredby}
                            onChange={(event) => {
                              setreferredby(event.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    name="submit"
                    type="button"
                    value="Submit"
                    onClick={UserRegistration}
                    disabled={btndisable}
                    className="btn btn-secondary shadow-secondary w-100"
                  >
                    Register
                  </button>
                  <p className="text-center m-t30">
                    Already registered?
                    <a className="font-weight-500" href="/">
                      Login
                    </a>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Register;
